// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/landing-technique.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/landing-technique/landing-technique.js';

mount([g0]);
